export class LoginContext {
    public loginName: string = '';
    public password: string = '';

    /**
     * Clears credentials from the context.
     */
    resetCredentials() {
        this.loginName = '';
        this.password = '';
    }
}
